import React from "react";
import InstagramLogo from "./logos/instagram-logo";
import LinkedInLogo from "./logos/linkedin-logo";
import YoutubeInLogo from "./logos/youtube-logo";
import TiktokInLogo from "./logos/tiktok-logo";
import "./social-media.scss";
import JobteaserLogo from "./logos/jobteaser-logo";

const SocialMedia = (props) => {
    const { className = "" } = props;
    return (
        <ul className={`social-media ${className}`}>
            <li>
                <a href="https://www.linkedin.com/company/capgemini" className="social-media__logo linkedin" target="_blank" rel="noreferrer">
                    <LinkedInLogo />
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/@capgemini-france" className="social-media__logo jobteaser" target="_blank" rel="noreferrer">
                    <YoutubeInLogo />
                </a>
            </li>
            <li>
                <a href="https://www.tiktok.com/@capgemini.france?lang=fr " className="social-media__logo jobteaser" target="_blank" rel="noreferrer">
                    <TiktokInLogo />
                </a>
            </li>
            <li>
                <a href="https://www.instagram.com/capgeminifr/?hl=fr" className="social-media__logo instagram" target="_blank" rel="noreferrer">
                    <InstagramLogo />
                </a>
            </li>
            <li>
                <a href="https://www.jobteaser.com/fr/companies/capgemini" className="social-media__logo instagram" target="_blank" rel="noreferrer">
                    <JobteaserLogo />
                </a>
            </li>
        </ul>
    );
};

export default SocialMedia;
